import LogoTitle from '../../assets/images/w-logo.png'
import { Link } from 'react-router-dom'
import './index.scss'
import { useEffect, useState } from 'react'
import { AnimatedLetters } from '../AnimatedLetters'
import { Logo } from './Logo'
import Loader from 'react-loaders'


export const Home = () => {

    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = "illiam".split("");
    const jobArray = "Fullstack developer".split("");

    useEffect(() => {
      setTimeout(() => {
        return setLetterClass('text-animate-hover')
      }, 4000)
    }, [])
    

    return (
        <>
            <div className="container home-page">
                <div className="text-zone">
                    <h1>
                        <span className={ letterClass }>H</span>
                        <span className={ `${letterClass} _12` }>i,</span>
                    <br/>
                    <span className={ `${letterClass} _13` }>I</span>
                    <span className={ `${letterClass} _14` }>'m</span>
                    <img src={LogoTitle} alt="developer"/>
                    <AnimatedLetters letterClass={ letterClass } strArray={ nameArray } idx={ 16 } />
                    <br/>
                    <AnimatedLetters letterClass={ letterClass } strArray={ jobArray } idx={ 12 } />
                    </h1>
                    <h2>React.js / Node.js / MongoDB / Express.js</h2>
                    <Link to="/contact" className="flat-button">CONTACT ME</Link>
                </div>
                <Logo/>
            </div>
            <Loader type='pacman' />
        </>
    );
}